import { Ghost } from "@/components/Button/Ghost"
import { Primary } from "@/components/Button/Primary"
import { Secondary } from "@/components/Button/Secondary"
import { Tertiary } from "@/components/Button/Tertiary"

export const Button = {
	Primary,
	Secondary,
	Tertiary,
	Ghost
}